<template>
  <div class="container" v-async="loading">
    <div class="row">
      <div class="col-xs-12">
        <h3 class="title">F.A.Q. (Perguntas Frequentes)</h3>
        <hr class="h-rule-yellow">
        <hr class="h-rule-side-yellow">
        <p class="line-height-20">
          Confira aqui as as respostas das perguntas mais frequentes:
        </p>
      </div>
    </div>
    <div class="content">
      <!-- adesao -->
      <div class="row margin-b30">
        <div class="col-xs-12">
          <div class="plan-line-purple margin-b20">
            <p class="bold upper">adesão</p>
          </div>
          <div class="question-box margin-b20">
            <h4 class="bold-600">
              <i class="icon-arrow-major-breadcrumb"></i>
              Sou Pessoa física, existe cobrança de mensalidade?
            </h4>
            <div class="answer-box">
              <p class="line-height-20">
                Não, devido nossos planos serem pré-pagos, é necessário somente o pagamento de adesão e recarga.
                Para saber mais sobre nossa tabela de recargas e tarifas, acesse:
                <router-link class="link" :to="{name: 'services'}" tag="a">
                  Recargas
                </router-link>
              </p>
            </div>
          </div>

          <div class="question-box margin-b20">
            <h4 class="bold-600">
              <i class="icon-arrow-major-breadcrumb"></i>
              Onde posso usar a Move Mais? Em qual cidade ou estado?
            </h4>
            <div class="answer-box">
              <p class="line-height-20">
                Estamos presentes em 100% dos Estados com vias pedagiadas do Brasil. Para consultar a cobertura completa da Move Mais, acesse:
                <router-link class="link" :to="{name: 'range'}" tag="a">
                  Cobertura
                </router-link>
              </p>
            </div>
          </div>

          <div class="question-box margin-b20">
            <h4 class="bold-600">
              <i class="icon-arrow-major-breadcrumb"></i>
              Quais são as vantagens que a Move Mais oferece?
            </h4>
            <div class="answer-box">
              <p class="line-height-20">
                Mais que um Sistema de Pagamento Automático de Pedágios, a Move Mais oferece um conjunto de serviços que
                facilita a relação com o seu carro, onde você estiver. Através do Portal Move Mais ou do aplicativo para
                smartphones (Android e IOS), você pode usufruir de todos os serviços que a Move Mais oferece, consultar o histórico
                das passagens e transações, gerenciar sua conta e consultar seu saldo a qualquer hora e em qualquer lugar. Sem se
                preocupar com mensalidades ou fidelidade, você escolhe um dos Planos Pré-pagos: Pré-pago Manual ou Pré-pago
                Automático. E escolhe também um Valor de Recarga disponível. E contando sempre com a Central de Relacionamento,
                <strong>24 horas por dia e 7 dias por semana</strong>.
              </p>
            </div>
          </div>

          <div class="question-box margin-b20">
            <h4 class="bold-600">
              <i class="icon-arrow-major-breadcrumb"></i>
              Quais as formas de pagamento disponíveis?
            </h4>
            <div class="answer-box">
              <p class="line-height-20">
                Para os Planos Pré-pagos a forma de pagamento disponível é com cartão de crédito.
              </p>
            </div>
          </div>

          <div class="question-box margin-b20">
            <h4 class="bold-600">
              <i class="icon-arrow-major-breadcrumb"></i>
              O meu saldo expira?
            </h4>
            <div class="answer-box">
              <p class="line-height-20">
                Não expira e o saldo fica disponível em sua conta por tempo indeterminado ou até a próxima viagem.
              </p>
            </div>
          </div>

          <div class="question-box margin-b20">
            <h4 class="bold-600">
              <i class="icon-arrow-major-breadcrumb"></i>
              Como eu sei a categoria do meu veículo?
            </h4>
            <div class="answer-box">
              <p class="line-height-20">
                A categoria do veículo é definida pela quantidade de eixos que ele possui. Por exemplo, veículos com dois
                eixos de rodagem simples (passeio e utilitários) correspondem à categoria 1, veículos com dois eixos de rodagem
                dupla correspondem à categoria 2, veículos com três eixos de rodagem dupla correspondem à categoria 3, e assim por
                diante. A categoria do seu veículo pode ser encontrada no documento CRLV. Para consultar as categorias completa de veículos, acesse:
                <span><a class="link" href="/api/v2/archeion/downloadFileArcheion/categoria-veiculos" target="_blank">
									Categorias
								</a></span>
              </p>
            </div>
          </div>

          <div class="question-box margin-b20">
            <h4 class="bold-600">
              <i class="icon-arrow-major-breadcrumb"></i>
              O TAG poderá ser usada para verificar outros dados (velocidade e/ou documentação do veículo) para aplicação de multas?
            </h4>
            <div class="answer-box">
              <p class="line-height-20">
                Não, o TAG é exclusiva para identificação e pagamento nas praças de pedágio conveniados à Move Mais.
              </p>
            </div>
          </div>

          <div class="question-box margin-b20">
            <h4 class="bold-600">
              <i class="icon-arrow-major-breadcrumb"></i>
              Existe limite de veículos por contrato?
            </h4>
            <div class="answer-box">
              <p class="line-height-20">
                Não temos limite mínimo, sempre que você quiser pode adicionar outros veículos em um só contrato.
                Além disso, na Move Mais você pode ter vários contratos em seu nome, com opções de planos e veículos diferentes em cada um deles.
              </p>
            </div>
          </div>

          <div class="question-box margin-b20">
            <h4 class="bold-600">
              <i class="icon-arrow-major-breadcrumb"></i>
              Na Move Mais existe cláusula de fidelidade?
            </h4>
            <div class="answer-box">
              <p class="line-height-20">
                Não, em nossos planos Pré-pagos não existe cláusula de fidelidade, dando autonomia para encerrar o contrato quando preferir.
              </p>
            </div>
          </div>
        </div>
      </div>

      <!-- tag -->
      <div class="row margin-b30">
        <div class="col-xs-12">
          <div class="plan-line-blue margin-b20">
            <p class="bold upper">tag</p>
          </div>
          <div class="question-box margin-b20">
            <h4 class="bold-600">
              <i class="icon-arrow-major-breadcrumb"></i>
              Recebi meu TAG. O que fazer?
            </h4>
            <div class="answer-box">
              <p class="line-height-20">
                O TAG é enviado bloqueada por motivo de segurança, neste caso basta acessar o site movemais.com
                realizar a ativação ou entrar em contato através dos telefones 4000 2901 (Capitais e Regiões Metropolitanas)
                e 0800 777 1022 (Demais Localidades). É de suma importância que o TAG seja desbloqueado para fazer o uso.
                Após a ativação a concessionária tem o prazo de até 6h para atualização de lista.
              </p>
            </div>
          </div>

          <div class="question-box margin-b20">
            <h4 class="bold-600">
              <i class="icon-arrow-major-breadcrumb"></i>
              Vendi meu veículo. O que devo fazer?
            </h4>
            <div class="answer-box">
              <p class="line-height-20">
                Devido o TAG ser intransferível é necessário realizar a solicitação de cancelamento do veículo através
                do e-mail : <a href="mailto:relacionamento@movemais.com">relacionamento@movemais.com</a>, informando o motivo, a placa e o CPF.
              </p>
            </div>
          </div>

          <div class="question-box margin-b20">
            <h4 class="bold-600">
              <i class="icon-arrow-major-breadcrumb"></i>
              Como eu faço se meu veículo for roubado?
            </h4>
            <div class="answer-box">
              <p class="line-height-20">
                Entre em contato com a Central de Relacionamento Move Mais. Solicite o bloqueio de seu TAG ou realize o
                bloqueio direto pela sua conta Move Mais, acessando a Área <strong>"Ver Veículos"</strong>. Caso preferir, temos outras formas de
                contato. Pelos telefones 4000 2901 (Capitais e Regiões Metropolitanas) e 0800 777 1022 (Demais Localidades) ou e-mail:
                <a href="mailto:relacionamento@movemais.com">relacionamento@movemais.com</a>.
              </p>
            </div>
          </div>

          <div class="question-box margin-b20">
            <h4 class="bold-600">
              <i class="icon-arrow-major-breadcrumb"></i>
              Tenho dois equipamentos instalados no meu veículo (Move Mais e outro). Isso pode causar problema na
              leitura dos TAGs ou confusão nos sistemas de captação do sinal?
            </h4>
            <div class="answer-box">
              <p class="line-height-20">
                O sinal será captado por todos os leitores e o usuário deve ser cobrado em apenas um sistema.
                O sistema da concessionária irá atribuir a cobrança ao TAG que foi lido primeiro e descartará a
                leitura do segundo aparelho.
              </p>
            </div>
          </div>

          <div class="question-box margin-b20">
            <h4 class="bold-600">
              <i class="icon-arrow-major-breadcrumb"></i>
              Após recarregar o TAG bloqueado por insuficiência de saldo, já posso voltar a utilizar normalmente ou é preciso esperar algum período para utilização?
            </h4>
            <div class="answer-box">
              <p class="line-height-20">
                Após recarregar o TAG bloqueado por insuficiência de saldo, você precisará aguardar o tempo de processamento
                de acordo com cada instituição bancária. Após a confirmação do pagamento, o crédito é disponibilizado na sua conta
                Move Mais e estará liberado para uso nos pedágios. O prazo é de até <strong>6 horas</strong>, tempo necessário para atualização nas concessionárias.
              </p>
            </div>
          </div>

          <div class="question-box margin-b20">
            <h4 class="bold-600">
              <i class="icon-arrow-major-breadcrumb"></i>
              Meu TAG esta descolando. O que fazer?
            </h4>
            <div class="answer-box">
              <p class="line-height-20">
                Neste caso entre em contato através do e-mail <a href="mailto:relacionamento@movemais.com">relacionamento@movemais.com</a> enviando uma <strong>foto</strong> do TAG,
                informando o número da placa do veículo e o CPF.
              </p>
            </div>
          </div>

          <div class="question-box margin-b20">
            <h4 class="bold-600">
              <i class="icon-arrow-major-breadcrumb"></i>
              Solicitei o cancelamento do meu TAG mas tenho saldo. O que acontece com o saldo?
            </h4>
            <div class="answer-box">
              <p class="line-height-20">
                O saldo disponível fica vinculado ao seu contrato e não ao TAG, sendo assim compartilhado entre os veículos cadastrados.
              </p>
            </div>
          </div>

          <div class="question-box margin-b20">
            <h4 class="bold-600">
              <i class="icon-arrow-major-breadcrumb"></i>
              Troquei de veículo, posso usar o mesmo TAG?
            </h4>
            <div class="answer-box">
              <p class="line-height-20">
                Não! Nesse caso, você precisa realizar uma nova adesão em seu contrato, pois o TAG é intransferível.
                Essa adesão é realizada em nosso site, acesse: <strong>"Minha Conta"</strong> e na área de <strong>"Planos”</strong>
                clique em <strong>"Adicionar veículo"</strong>, para incluir o novo veículo em seu contrato.
              </p>
            </div>
          </div>

          <div class="question-box margin-b20">
            <h4 class="bold-600">
              <i class="icon-arrow-major-breadcrumb"></i>
              Alterei minha placa para o modelo Mercosul. O que devo fazer?
            </h4>
            <div class="answer-box">
              <p class="line-height-20">
                Entre imediatamente em contato com a Move Mais, através do e-mail <a href="mailto:relacionamento@movemais.com">relacionamento@movemais.com</a>,
                solicitando alteração da placa antiga e enviando o documento do veículo atualizado, junto com o CPF.
              </p>
            </div>
          </div>

          <div class="question-box margin-b20">
            <h4 class="bold-600">
              <i class="icon-arrow-major-breadcrumb"></i>
              Como adicionar um novo veículo?
            </h4>
            <div class="answer-box">
              <p class="line-height-20">
                Basta acessar sua conta da Move Mais e clicar na opção <strong>"Adicionar Veículos"</strong> e realizar a adesão.
              </p>
            </div>
          </div>

          <div class="question-box margin-b20">
            <h4 class="bold-600">
              <i class="icon-arrow-major-breadcrumb"></i>
              Caso a cancela não abra o que devo fazer?
            </h4>
            <div class="answer-box">
              <p class="line-height-20">
                Deverá entrar em contato com a Central de Relacionamento através dos telefones 4000 2901 (Capitais e Regiões Metropolitanas)
                e 0800 777 1022 (Demais Localidades), informando o ocorrido. Será analisado o motivo da não abertura automática da cancela.
              </p>
            </div>
          </div>

          <div class="question-box margin-b20">
            <h4 class="bold-600">
              <i class="icon-arrow-major-breadcrumb"></i>
              O Sistema de leitura dos TAGs pode ficar comprometido em dias de trânsito intenso?
            </h4>
            <div class="answer-box">
              <p class="line-height-20">
                Não! A funcionalidade de leitura do seu TAG não será comprometida com volume maior ou menor de veículos.
              </p>
            </div>
          </div>

          <div class="question-box margin-b20">
            <h4 class="bold-600">
              <i class="icon-arrow-major-breadcrumb"></i>
              Em caso de problemas com o TAG, o que devo fazer para substituí-lo?
            </h4>
            <div class="answer-box">
              <p class="line-height-20">
                Se seu TAG apresentar algum problema de leitura, você poderá solicitar uma análise à Central de Relacionamento
                através do e-mail <a href="mailto:relacionamento@movemais.com">relacionamento@movemais.com</a> ou pelos telefones 4000 2901 (Capitais e Regiões Metropolitanas) e
                0800 777 1022 (Demais Localidades). Se for confirmada a falha, você será orientado sobre o procedimento de troca.
              </p>
            </div>
          </div>

          <div class="question-box margin-b20">
            <h4 class="bold-600">
              <i class="icon-arrow-major-breadcrumb"></i>
              O TAG pode ser removido e utilizado em outro veículo?
            </h4>
            <div class="answer-box">
              <p class="line-height-20">
                Não! O TAG é intransferível pois é vinculado a placa, caso for removido o mesmo ficará inutilizável.
              </p>
            </div>
          </div>

          <div class="question-box margin-b20">
            <h4 class="bold-600">
              <i class="icon-arrow-major-breadcrumb"></i>
              O que acontece se eu não instalar o TAG no para-brisa do carro e usá-lo na mão quando estiver passando na cancela?
            </h4>
            <div class="answer-box">
              <p class="line-height-20">
                O TAG possui um mecanismo de segurança que o inutiliza em caso de remoção ou tentativa de remoção do para-brisa.
                Se for removido, é necessário adquirir um novo TAG. Se o TAG for utilizado de forma indevida (na mão, sem instalar no para-brisa),
                o sistema identifica essa prática por meio de fotografias tiradas nas praças de pedágio e bloqueia a sua utilização,
                fazendo assim com que a cancela não abra. Além disso, o cliente estará sujeito à multa por uso indevido do TAG.
              </p>
            </div>
          </div>

          <div class="question-box margin-b20">
            <h4 class="bold-600">
              <i class="icon-arrow-major-breadcrumb"></i>
              Em quais situações o TAG poderá ser bloqueado?
            </h4>
            <div class="answer-box">
              <p class="line-height-20">
                O TAG poderá ser bloqueado em caso de uso indevido, insuficiência de saldo ou nos casos de perda, roubo ou extravio.
              </p>
            </div>
          </div>

          <div class="question-box margin-b20">
            <h4 class="bold-600">
              <i class="icon-arrow-major-breadcrumb"></i>
              Assim que ativar o TAG já posso passar pelo pedágio?
            </h4>
            <div class="answer-box">
              <p class="line-height-20">
                Não! Após o TAG ser ativado no sistema, é necessário aguardar um prazo de até <strong>6 horas</strong> para poder
                utilizar as praças de pedágios, pois as mesmas têm este prazo para consumirem as listas com as informações atuais do seu veículo.
              </p>
            </div>
          </div>
        </div>
      </div>

      <!-- cobrança -->
      <div class="row margin-b30">
        <div class="col-xs-12">
          <div class="plan-line-red margin-b20">
            <p class="bold upper">cobrança</p>
          </div>
          <div class="question-box margin-b20">
            <h4 class="bold-600">
              <i class="icon-arrow-major-breadcrumb"></i>
              Caso meu veículo seja guinchado o que fazer?
            </h4>
            <div class="answer-box">
              <p class="line-height-20">
                Trabalhamos com as seguintes situações. <strong>Guincho particular:</strong> caso o mesmo possua TAG, será atribuída a tarifa do pedágio ao mesmo.
                <strong>Guincho da concessionária:</strong> nesse caso é isento de tarifa pela ARTESP (Agência de Transporte do Estado de SP). A tarifa de
                pedágio será cobrada pelo veículo. <strong>Caso ambos os veículos possuirem TAG:</strong> nessa situação é necessário o cliente realizar
                o bloqueio temporário antes da viagem, através de sua conta Move Mais ou via Central de Relacionamento. Não havendo bloqueio
                temporário, a concessionária informa que a cobrança deve ser acordada entre o usuário e o Guincho. Caso haja o débito em ambos
                os veículos, guincho e em seu TAG, será necessário o envio da solicitação de contestação, sendo analisado junto a concessionária.
              </p>
            </div>
          </div>

          <div class="question-box margin-b20">
            <h4 class="bold-600">
              <i class="icon-arrow-major-breadcrumb"></i>
              O que fazer se eu receber uma multa por evasão?
            </h4>
            <div class="answer-box">
              <p class="line-height-20">
                Entrar em contato com a Central de Relacionamento através do e-mail <a href="mailto:relacionamento@movemais.com">relacionamento@movemais.com</a>
                enviando uma cópia da autuação para analisarmos se a mesma será procedente ou improcedente.
              </p>
            </div>
          </div>

          <div class="question-box margin-b20">
            <h4 class="bold-600">
              <i class="icon-arrow-major-breadcrumb"></i>
              Para caso de débito automático em conta, o titular deverá ser o mesmo que cadastrado na Move Mais?
            </h4>
            <div class="answer-box">
              <p class="line-height-20">
                Sim, o titular da conta corrente deve ser o mesmo da conta Move Mais.
              </p>
            </div>
          </div>

          <div class="question-box margin-b20">
            <h4 class="bold-600">
              <i class="icon-arrow-major-breadcrumb"></i>
              Para caso de pagamento com Cartão de Crédito, o titular deverá ser o mesmo que cadastrado na Move Mais?
            </h4>
            <div class="answer-box">
              <p class="line-height-20">
                O titular do cartão de crédito não precisa ser o mesmo cadastrado na Move Mais.
              </p>
            </div>
          </div>

          <div class="question-box margin-b20">
            <h4 class="bold-600">
              <i class="icon-arrow-major-breadcrumb"></i>
              Tenho alguns veículos com TAG Move Mais. É possível recarregá-los separadamente?
            </h4>
            <div class="answer-box">
              <p class="line-height-20">
                Para facilitar a sua vida, aqui na Move Mais a recarga é feita por contrato e não por veículo cadastrado.
                Assim, se você possui mais de um veículo no mesmo contrato, não precisa ficar se preocupando em fazer
                recargas para cada um deles separadamente, pois os veículos desse contrato compartilham da recarga efetuada.
                Para os casos em que o cliente desejar recarregar seus veículos de forma separada, é possível abrir novos
                contratos e realizar recargas independentes para cada um deles.
              </p>
            </div>
          </div>

          <div class="question-box margin-b20">
            <h4 class="bold-600">
              <i class="icon-arrow-major-breadcrumb"></i>
              Meu crédito é insuficiente e a viagem ainda não acabou. Como faço para recarregar créditos?
            </h4>
            <div class="answer-box">
              <p class="line-height-20">
                Você pode fazer a recarga através da sua contra acessando nosso site movemais.com ou através de nosso aplicativo.
              </p>
            </div>
          </div>

          <div class="question-box margin-b20">
            <h4 class="bold-600">
              <i class="icon-arrow-major-breadcrumb"></i>
              Ao usar o serviço da Move Mais, eu pagarei a mesma tarifa praticada nos pedágios?
            </h4>
            <div class="answer-box">
              <p class="line-height-20">
                Sim, a tarifa é a mesma cobrada nos pedágios. Os valores são tabelados.
              </p>
            </div>
          </div>

          <div class="question-box margin-b20">
            <h4 class="bold-600">
              <i class="icon-arrow-major-breadcrumb"></i>
              Se eu estiver inadimplente com o pagamento, serei bloqueado na passagem pelo pedágio? Ou serei multado por
              evasão de pedágio?
            </h4>
            <div class="answer-box">
              <p class="line-height-20">
                Sim, será bloqueado. E, se não pagar o pedágio manualmente, será multado por evasão.
              </p>
            </div>
          </div>

          <div class="question-box margin-b20">
            <h4 class="bold-600">
              <i class="icon-arrow-major-breadcrumb"></i>
              Quais são os valores disponíveis para recarga nos planos pré-pagos?
            </h4>
            <div class="answer-box">
              <p class="line-height-20">
                Para Pessoa Física as recargas são múltiplas de R$50,00, enquanto que para Pessoa Jurídica,
                os valores são múltiplos de R$ 500,00. Para verificar as formas de pagamento por plano, acesse:
                <router-link class="link" :to="{name: 'services'}" tag="a">
                  Serviços
                </router-link>
              </p>
            </div>
          </div>

          <div class="question-box margin-b20">
            <h4 class="bold-600">
              <i class="icon-arrow-major-breadcrumb"></i>
              Nos planos Pré-pagos eu consigo colocar créditos do meu celular? O crédito é disponibilizado na hora?
            </h4>
            <div class="answer-box">
              <p class="line-height-20">
                Nos planos Pré-Pagos você recarrega sua conta Move Mais quando achar conveniente. A recarga pode ser
                feita a qualquer momento, através do site Move Mais ou pelo App. A recarga será disponibilizada em
                até 30 minutos em sua conta Move Mais. Para verificar a tabela de recarga, acesse:
                <router-link class="link" :to="{name: 'services'}" tag="a">
                  Serviços
                </router-link>
              </p>
            </div>
          </div>

          <div class="question-box margin-b20">
            <h4 class="bold-600">
              <i class="icon-arrow-major-breadcrumb"></i>
              A Move Mais emite nota fiscal?
            </h4>
            <div class="answer-box">
              <p class="line-height-20">
                A Move Mais é uma empresa de meios de pagamento eletrônico de pedágio, neste caso é feito a emissão apenas
                de serviços prestados, no entanto a nota fiscal das passagens deve ser solicitada através das concessionárias
                devido a mesma ser responsável pelas cobranças em seu TAG.
              </p>
            </div>
          </div>

        </div>
      </div>

      <!-- serviços -->
      <div class="row margin-b30">
        <div class="col-xs-12">
          <div class="plan-line-green margin-b20">
            <p class="bold upper">serviços</p>
          </div>
          <div class="question-box margin-b20">
            <h4 class="bold-600">
              <i class="icon-arrow-major-breadcrumb"></i>
              Qual é a velocidade máxima nas praças de pedágio?
            </h4>
            <div class="answer-box">
              <p class="line-height-20">
                Para evitar acidentes e colisões nas praças de pedágio, respeite o limite de velocidade máxima
                de <strong>40 km/h</strong> sinalizado nas pistas de pedágio, sujeito à multa e pontos na carteira.
              </p>
            </div>
          </div>

          <div class="question-box margin-b20">
            <h4 class="bold-600">
              <i class="icon-arrow-major-breadcrumb"></i>
              A Move Mais tem transferência de saldo? Como faço para transferir meu saldo?
            </h4>
            <div class="answer-box">
              <p class="line-height-20">
                Nesse caso, basta acessar sua conta através do site movemais.com, e clicar na opção <strong>"Transferir Saldo"</strong>.
                À cada transferência é cobrado o valor de <strong>2%</strong>.
              </p>
            </div>
          </div>

          <div class="question-box margin-b20">
            <h4 class="bold-600">
              <i class="icon-arrow-major-breadcrumb"></i>
              Esqueci minha senha. E agora?
            </h4>
            <div class="answer-box">
              <p class="line-height-20">
                Basta entrar em contato com nossa Central de Relacionamento através dos telefones: 4000 2901 (Capitais e Regiões Metropolitanas)
                e 0800 777 1022 (Demais Localidades). Enviaremos uma recuperação através do e-mail cadastrado.
              </p>
            </div>
          </div>

          <div class="question-box margin-b20">
            <h4 class="bold-600">
              <i class="icon-arrow-major-breadcrumb"></i>
              A Move Mais tem uma cabine específica para passagens nos pedágios?
            </h4>
            <div class="answer-box">
              <p class="line-height-20">
                Nas praças de pedágio você deve usar as pistas com cobranças automáticas, que estarão devidamente sinalizadas.
              </p>
            </div>
          </div>

          <div class="question-box margin-b20">
            <h4 class="bold-600">
              <i class="icon-arrow-major-breadcrumb"></i>
              Como faço para solicitar o cancelamento do meu plano Pré-pago?
            </h4>
            <div class="answer-box">
              <p class="line-height-20">
                O cancelamento dos serviços Move Mais poderá ser feito através do e-mail <a href="mailto:relacionamento@movemais.com">relacionamento@movemais.com</a>,
                contendo CPF ou CNPJ, motivo do cancelamento e uma conta bancária de titularidade do cliente.
              </p>
            </div>
          </div>

          <div class="question-box margin-b20">
            <h4 class="bold-600">
              <i class="icon-arrow-major-breadcrumb"></i>
              Sou pessoa física, solicitei o cancelamento do contrato mas tenho saldo disponível. O que devo fazer?
            </h4>
            <div class="answer-box">
              <p class="line-height-20">
                Nesse caso, realizamos o <strong>estorno do saldo residual</strong> e o prazo para reembolso é de 60 dias à partir da data do cancelamento do contrato.
                A taxa de cancelamento é de R$ 7,00.
              </p>
            </div>
          </div>

          <div class="question-box margin-b20">
            <h4 class="bold-600">
              <i class="icon-arrow-major-breadcrumb"></i>
              De quem é a responsabilidade pela manutenção das praças de pedágios e rodovias?
            </h4>
            <div class="answer-box">
              <p class="line-height-20">
                A manutenção das rodovias é de responsabilidade da administradora responsável pela concessão, ou seja, a concessionária.
                Qualquer dano causado ao patrimônio particular e público, incluindo as praças de pedágio, rodovias e outros, está sujeito
                a eventuais penalidades na forma da legislação brasileira.
              </p>
            </div>
          </div>

          <div class="question-box margin-b20">
            <h4 class="bold-600">
              <i class="icon-arrow-major-breadcrumb"></i>
              Em caso de parada de veículo em fila o que devo fazer?
            </h4>
            <div class="answer-box">
              <p class="line-height-20">
                Se o veículo a sua frente parar, aguarde que o mesmo saia da pista automática e passe normalmente.
                Mantenha sempre uma distância e velocidade segura do veículo à sua frente, para evitar colisões e acidentes.
                Se após a passagem do veículo à sua frente, o semáforo continuar vermelho, aguarde orientação de algum funcionário da
                concessionária, para evitar autuação por evasão de pedágio.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style lang="scss" scoped>
  h4 {
    margin-bottom:                      20px;
    cursor:                             pointer;
  }
  .icon-arrow-major-breadcrumb {
    display:                            inline-block;
    -o-transition:                      .4s;
    -ms-transition:                     .4s;
    -moz-transition:                    .4s;
    transition:                         .4s;
    &.open {
      -ms-transform:                    rotate(90deg);
      -webkit-transform:                rotate(90deg);
      transform:                        rotate(90deg);
    }
  }
  .answer-box {
    max-height:                         1px;
    overflow:                           hidden;
    border-top:                         1px solid #f2f2f2;
    p {
      padding:                          10px 20px;
    }
    &.open {
      max-height:                       100%;
      -o-transition:                    max-height .8s ease-in;
      -ms-transition:                   max-height .8s ease-in;
      -moz-transition:                  max-height .8s ease-in;
      transition:                       max-height .8s ease-in;
    }
  }
  .plan-line-green,
  .plan-line-red,
  .plan-line-blue {
    text-align: center;
    -webkit-border-radius: 5px;
    border-radius: 5px;
    color: white;
  }
  .plan-line-blue {
    background-color: #0074C8;
  }
  .plan-line-red {
    background-color: #FC4513;
  }
  .plan-line-green {
    background-color: #61A60E;
  }
</style>
<script type="text/javascript">
export default {
  mounted(){
    let el = $(this.$el);
    el.find('.question-box h4').click(function(){
      el.find('.open').removeClass('open');
      $(this).find('i').addClass('open');
      $(this).parent().find('.answer-box').addClass('open');
    });
  }
}
</script>



// WEBPACK FOOTER //
// faq.vue?8059b4d8